import {atom} from 'recoil';

import {FilterType, IFiltersSet} from '../../shared/types/filtersSet.types';

export const triggerFiltersServiceRequestsQuery = atom<number>({
  key: 'triggerFiltersServiceRequestsQuery',
  default: 0,
});

export const filtersServiceRequestsSetsState = atom<IFiltersSet[]>({
  key: 'filtersServiceRequestsSetsState',
  default: [],
});

//______________
export const filtersServiceRequestsToAssignState = atom<FilterType[]>({
  key: 'filtersServiceRequestsToAssignState',
  default: [],
});
export const currentServiceRequestsToAssignFiltersSetState = atom<IFiltersSet | null>({
  key: 'currentServiceRequestsToAssignFiltersSetState',
  default: null,
});

//______________
export const filtersServiceRequestsState = atom<FilterType[]>({
  key: 'filtersServiceRequestsState',
  default: [],
});
export const currentServiceRequestsFiltersSetState = atom<IFiltersSet | null>({
  key: 'currentServiceRequestsFiltersSetState',
  default: null,
});
